import React from "react";
import { ArrowRight, ArrowDown } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const HERO_IMG = "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/p6j88y5t_ChatGPT%20Image%20Mar%203%2C%202026%2C%2008_57_12%20PM.png";

const Hero = () => {
  const { t } = useLanguage();
  const goTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" data-testid="hero-section" className="relative min-h-screen w-full overflow-hidden bg-[#0F0F0F]">
      {/* Full-screen luxury villa background */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Luxury villa engineering"
          className="w-full h-full object-cover"
        />
        {/* Premium dark gradient overlay for readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/45 to-black/85"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-transparent to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-20 pt-40 pb-32 min-h-screen flex flex-col justify-center">
        <div className="reveal flex items-center gap-4 mb-10">
          <span className="w-14 h-px bg-[#B08D57]"></span>
          <span className="overline-bold text-[#B08D57]" data-testid="hero-overline">{t.hero.overline}</span>
        </div>

        <h1
          data-testid="hero-title"
          className="reveal-up font-display-thin text-white text-[56px] sm:text-[88px] lg:text-[120px] xl:text-[148px] leading-[0.92] tracking-tight max-w-6xl uppercase"
        >
          {t.hero.title_a}
          <br />
          <span className="text-[#B08D57]">{t.hero.title_b}</span>
          <br />
          {t.hero.title_c}
        </h1>

        <p
          data-testid="hero-subtitle"
          className="reveal mt-12 max-w-2xl text-white/85 text-base sm:text-lg leading-[1.75] font-light"
        >
          {t.hero.subtitle}
        </p>
        <p className="reveal mt-3 overline-bold text-[#B08D57]">
          {t.hero.locations}
        </p>

        <div className="reveal mt-14 flex flex-wrap items-center gap-5">
          <button
            data-testid="hero-cta-quote"
            onClick={() => goTo("contact")}
            className="group inline-flex items-center gap-4 bg-[#B08D57] text-[#0F0F0F] px-10 py-5 text-[11px] tracking-[0.3em] uppercase font-semibold hover:bg-white transition-colors"
          >
            {t.hero.cta_primary}
            <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
          </button>
          <button
            data-testid="hero-cta-projects"
            onClick={() => goTo("projects")}
            className="inline-flex items-center gap-3 text-white py-5 text-[11px] tracking-[0.3em] uppercase font-semibold hover:text-[#B08D57] transition-colors border-b border-white/40 hover:border-[#B08D57]"
          >
            {t.hero.cta_secondary}
            <ArrowRight className="w-3 h-3" />
          </button>
        </div>

        <div className="absolute bottom-12 right-12 hidden lg:flex items-center gap-3 text-white/60 animate-bounce">
          <ArrowDown className="w-4 h-4" strokeWidth={1.2} />
          <span className="overline text-[10px]">Scroll</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
